export default __webpack_public_path__ + "5e034ae828f1a6f3be6751b50bc0f8a6.svg";